<template>
  <DrupalLink
    v-if="url"
    :to="url"
    class="transition-all duration-250 shadow-sm bg-white border-1 border-gray-200 hover:border-gray-300 w-full rounded-[4px] flex flex-row items-stretch h-28 group overflow-hidden"
  >
    <slot :url="url" :title="title">
      <div
        class="transition-all duration-250 flex w-26 bg-gray-300 flex items-center justify-center"
      >
        <MediaImage
          v-if="image"
          v-bind="image"
          preload
          :image-style="imageStyle"
          loading="eager"
          class="relative w-full flex-1"
          hide-caption
          img-class="size-full"
          figure-class="size-full"
        />
        <MediaIcon
          v-else-if="icon"
          v-bind="icon"
          class="size-16 flex-1 text-darkGreen group-hover:text-violet"
        />
        <SpriteSymbol
          v-else
          name="link-default"
          class="size-16 text-darkGreen group-hover:text-violet"
        />
      </div>
      <span
        class="hyphens-auto transition-all duration-250 text-lg flex flex-1 items-center px-6 group-hover:text-violet"
        >{{ title }}
      </span>
    </slot>
  </DrupalLink>
</template>

<script lang="ts" setup>
import type {
  FieldItemTypeLinkDescriptionFragment,
  MediaImageFragment,
  MediaIconFragment,
  ParagraphLinkFragment,
  FieldItemTypeLinkDescriptionEntityFragment,
} from '#graphql-operations'

const props = defineProps<{
  linkTitle?: FieldItemTypeLinkDescriptionFragment['linkTitle']
  uri?: FieldItemTypeLinkDescriptionFragment['uri']
  linkMedia?: ParagraphLinkFragment['linkMedia']
}>()

const entity = computed<FieldItemTypeLinkDescriptionEntityFragment | undefined>(
  () => {
    if (props.uri && 'entity' in props.uri) {
      return props.uri.entity
    }
    return undefined
  },
)

const title = computed(() => {
  // Use provided link title.
  if (props.linkTitle) {
    return props.linkTitle
  }

  // Fallback to shwowing the URL. Better than nothing.
  return url.value
})

const image = computed(() => {
  if (props.linkMedia && 'image' in props.linkMedia) {
    return props.linkMedia as MediaImageFragment
  }
  return null
})

const icon = computed(() => {
  if (props.linkMedia && 'svg' in props.linkMedia) {
    return props.linkMedia as MediaIconFragment
  }
  return null
})

const imageStyle = defineImageStyle({
  type: 'sizes',
  aspectRatio: 1,
  sizes: {
    xs: 110,
  },
})

const url = computed(() => {
  if (entity.value && entity.value?.__typename === 'MediaDocument') {
    return entity.value?.mediaFileUrl?.path
  }

  return props.uri?.path
})
</script>
